import { jsonToGraphQLQuery } from 'json-to-graphql-query';
//santiago, implementar con localstorage
//let service_addres = 'http://localhost:8080/ServiciosVueJs/recursos/dj';

export default class SmartService {
    async setAmbiente() {
        var urlApiPAT = '';
        var urlApiMIDES = '';
        var urlIDUruguay = '';
        var urlLogin = '';
        var urlLogout = '';
        /* var urlCU=""; */ 
        var client_id = '';
        let ambiente = '';
        const url = window.location.href;
        if (url.includes('localhost')) {
            ambiente = 'local';
        } else if (url.includes('-int.mides.gub.uy/')) {
            ambiente = 'integracion';
        } else if (url.includes('-prep.mides.gub.uy/')) {
            ambiente = 'pre';
        } else {
            ambiente = 'produccion';
        }

        switch (ambiente) {
            case 'local':
                urlApiMIDES = 'https://apis-integra.mides.gub.uy/api_codigueras';
                urlApiPAT = 'https://apipat-int.mides.gub.uy/graphql';
                urlIDUruguay = 'https://auth-testing.iduruguay.gub.uy/oidc/v1';
                urlLogin = 'https://apps-int.mides.gub.uy/QRreader/iduy-login';
                urlLogout = 'https://apps-int.mides.gub.uy/QRreader/iduy-logout';
                /* urlCU="https://testtramites.mides.gub.uy/telmidesv2/portal/tramite.jsp?id=1001&envId=1";  */
                client_id = '590599'; //Actualizar client_id
                break;
            case 'integracion':
                urlApiMIDES = 'https://apis-integra.mides.gub.uy/api_codigueras';
                urlApiPAT = 'https://apipat-int.mides.gub.uy/graphql';
                urlIDUruguay = 'https://auth-testing.iduruguay.gub.uy/oidc/v1';
                urlLogin = 'https://apps-int.mides.gub.uy/QRreader/iduy-login';
                urlLogout = 'https://apps-int.mides.gub.uy/QRreader/iduy-logout';
                /* urlCU="https://testtramites.mides.gub.uy/telmidesv2/portal/tramite.jsp?id=1001&envId=1";  */
                client_id = '590599';
                break;
            case 'pre':
                urlApiMIDES = 'https://apis-preprod.mides.gub.uy/api_codigueras';
                urlApiPAT = 'https://apipat-prep.mides.gub.uy/graphql';
                urlIDUruguay = 'https://auth-testing.iduruguay.gub.uy/oidc/v1';
                urlLogin = 'https://apps-prep.mides.gub.uy/QRreader/iduy-login';
                urlLogout = 'https://apps-prep.mides.gub.uy/QRreader/iduy-logout';
                /* urlCU="https://testtramites.mides.gub.uy/telmidesv2/portal/tramite.jsp?id=1001&envId=1";  */
                client_id = '135578';
                break;
            case 'produccion':
                urlApiMIDES = 'https://apis.mides.gub.uy/api_codigueras';
                urlApiPAT = 'https://apipat.mides.gub.uy/graphql';
                urlIDUruguay = 'https://auth.iduruguay.gub.uy/oidc/v1';
                urlLogin = 'https://apps.mides.gub.uy/QRreader/iduy-login';
                urlLogout = 'https://apps.mides.gub.uy/QRreader/iduy-logout';
                /* urlCU="https://tramites.mides.gub.uy/telmidesv2/portal/tramite.jsp?id=1001&envId=1";  */
                client_id = '281245';
                break;
        }
        localStorage.urlApiMIDES = urlApiMIDES;
        localStorage.urlApiPAT = urlApiPAT;
        localStorage.urlIDUruguay = urlIDUruguay;
        localStorage.urlLogin = urlLogin;
        localStorage.urlLogout = urlLogout;
        /* localStorage.urlCU = urlCU; */ 
        localStorage.client_id = client_id;
        localStorage.ambiente = ambiente;
    }

    //ID Uruguay
    async autenticarIDU(codigo) {
        const query = {
            mutation: {
                loginIDUruguay: {
                    __args: {
                        code: codigo,
                    },
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiPAT, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors' },
            body: '{"query":' + JSON.stringify(graphql_query) + '}',
        });
        const tokenJson = await res.json();
        if (tokenJson.error) {
            return console.log(tokenJson.error);
        }
        const data = await JSON.parse(tokenJson.data.loginIDUruguay);
        console.log(JSON.stringify(data,null,'\t')); 
        return data;
    }

    //QR
    async getComedores() {
        const response = await fetch(localStorage.urlApiMIDES + '/come.Comedor');
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    }

    //QR
    async getMotivos() {
        const response = await fetch(localStorage.urlApiMIDES + '/come.CodMotivoEntregaExcepcional');
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    }

    //QR
    async getParadas(MovilId) {
        const response = await fetch(localStorage.urlApiMIDES + '/come.Parada?ComId=' + MovilId)
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    }

    //QR
    async autenticarSMART(app, user, pass) {
        try {
            const query = {
                mutation: {
                    loginGestUsu: {
                        __args: {
                            app: app,
                            pass: pass,
                            user: user,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiPAT, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors' },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const tokenJson = await res.json();
            if (tokenJson.error) {
                return console.log(tokenJson.error);
            }
            const token = await JSON.parse(tokenJson.data.loginGestUsu);
            return token;
        } catch (error) {
            console.log(error);
        }
    }

    //QR
    async registrarRetiroEx(cId, pId, mId, viandas, obs, tId) {
		try {
			const query = {mutation: {
				registrarRetiroExcepcional: {
                    __args: {
                        viandas: viandas,
                        obs: obs,
                        parId: pId,
                        idMotivo: mId,
                        comId: cId,
                        tecId: tId,
                    },
			}}};
			const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
			const res = await fetch(localStorage.urlApiPAT, {
					method: 'POST',
					headers: {'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Mode': 'no-cors',
					'Access-Control-Allow-Origin': '*',
					'Authorization': 'Bearer ' + localStorage.token,
					},
					body: '{"query":'+JSON.stringify(graphql_query)+'}',
				});
			const result = await res.json();
			const data = await JSON.parse(result.data.registrarRetiroExcepcional);
			return data.data.registrarRetiroExcepcional;
		} catch (error) {
			console.log(error)
		}
	}

    //QR
    async obtenerDatosQR(code, mult, cId) {
        const query = {
            obtenerDatosQR: {
                __args: {
                    qrCode: code,
                    multiplicador: mult,
                    comId: cId,
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiPAT, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":' + JSON.stringify('{' + graphql_query + '}') + '}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const result = await res.json();
        if (!result.errors){
            const datosQR = JSON.parse(result.data.obtenerDatosQR);
            return datosQR.data.obtenerDatosQR;
        }
        else{
            const datosQR = result.errors[0];
            console.log(datosQR.message);
            return datosQR.message;
        }
    }

    //QR
    async registrarRetiroQR(code, cId, pId, tId, mult) {
		try {
			const query = {mutation: {
				registrarRetiroQR: {
                    __args: {
                        qrCode: code,
                        parId: pId,
                        multiplicador: mult,
                        comId: cId,
                        tecId: tId,
                    },
			}}};
			const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
			const res = await fetch(localStorage.urlApiPAT, {
					method: 'POST',
					headers: {'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Mode': 'no-cors',
					'Access-Control-Allow-Origin': '*',
					'Authorization': 'Bearer ' + localStorage.token,
					},
					body: '{"query":'+JSON.stringify(graphql_query)+'}',
				});
			const result = await res.json();
			const data = await JSON.parse(result.data.registrarRetiroQR);
			return data.data.registrarRetiroQR;
		} catch (error) {
			console.log(error)
		}
	}

    //QR
    async cantidadesHoy(cId, tId) {
        const query = {
            obtenerReporteQR: {
                __args: {
                    comId: cId,
                    tecId: tId,
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiPAT, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":' + JSON.stringify('{' + graphql_query + '}') + '}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const result = await res.json();
        const cantidades = JSON.parse(result.data.obtenerReporteQR);
        return cantidades.data.obtenerReporteQR;
    }

    //QR
    async obtenerCodigoHoy(cId, tId) {
        const query = {
            obtenerRetirosHoy: {
                __args: {
                    comId: cId,
                    tecId: tId,
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiPAT, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":' + JSON.stringify('{' + graphql_query + '}') + '}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const result = await res.json();
        const retirosC = JSON.parse(result.data.obtenerRetirosHoy);
        return retirosC.data.obtenerRetirosHoy;
    }

    //QR
    async obtenerExcHoy(cId, tId) {
        const query = {
            obtenerRetirosExcepcionalesHoy: {
                __args: {
                    comId: cId,
                    tecId: tId,
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiPAT, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":' + JSON.stringify('{' + graphql_query + '}') + '}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const result = await res.json();
        const retirosE = JSON.parse(result.data.obtenerRetirosExcepcionalesHoy);
        return retirosE.data.obtenerRetirosExcepcionalesHoy;
    }

    //QR
    async registrarRemito(tr, cv, image, cid, obs, tid) {
		try {
			const query = {mutation: {
				registrarRemito: {
                    __args: {
                        tipo: tr,
                        cantViandas: cv,
                        imagen: image,
                        comId: cid,
                        observacion: obs,
                        tecId: tid,
                    },
			}}};
			const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
			const res = await fetch(localStorage.urlApiPAT, {
					method: 'POST',
					headers: {'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Mode': 'no-cors',
					'Access-Control-Allow-Origin': '*',
					'Authorization': 'Bearer ' + localStorage.token,
					},
					body: '{"query":'+JSON.stringify(graphql_query)+'}',
				});
			const result = await res.json();
			const data = await JSON.parse(result.data.registrarRemito);
			return data.data.registrarRemito;
		} catch (error) {
			console.log(error)
		}
	}

    async obtenerRemitosHoy(cId) {
        const query = {
            obtenerRemitosHoy: {
                __args: {
                    idComedor: cId,
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiPAT, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":' + JSON.stringify('{' + graphql_query + '}') + '}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const result = await res.json();
        const remitosC = JSON.parse(result.data.obtenerRemitosHoy);
        return remitosC.data.obtenerRemitosHoy;
    }

    async obtenerDietasHoy(cId) {
        const query = {
            obtenerDistribucionTDieHoy: {
                __args: {
                    idComedor: cId,
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiPAT, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":' + JSON.stringify('{' + graphql_query + '}') + '}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const result = await res.json();
        const dietashoy = JSON.parse(result.data.obtenerDistribucionTDieHoy);
        return dietashoy.data.obtenerDistribucionTDieHoy;
    }

}
